<template>
	<div class="content-module-container">
		<div class="content-module-block">
			<h2>{{ $t('enterprise.research-report-list') }}</h2>
			<div>
				<CommonSearch :value.sync="searchValue" class="mt-5" @change="changeSearch" />
			</div>
		</div>

		<MStateBox :loading="isLoading" :empty="isEmpty" emptyText="暂无研报">
			<div class="report-list">
				<FileInfoCard
					v-for="item in currentData"
					:key="item.id"
					:item="item"
					:formatter="item => ({fileUrl: item.url})"
					class="report-list--item"
					@click="handlePreview(item)"
				>
					<template #date>
						<div class="date date--report">
							<span class="one-line text-overflow">{{ item.orgName }} | {{ item.author }}</span>
							<span class="ml-16">{{ formatDateFn(item.time) }}</span>
						</div>
					</template>
				</FileInfoCard>
			</div>
			<el-pagination
				v-if="pageTotal"
				@size-change="changePageSize"
				@current-change="changeCurrentPage"
				:current-page="currentPage"
				:page-sizes="pageSizes"
				:page-size="pageSize"
				:layout="pageLayout"
				:total="pageTotal"
				background
			></el-pagination>
		</MStateBox>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import FileInfoCard from '@rebuild/materials/shared/common/FileInfoCard.vue';
import { usePaginationPC } from '@rebuild/hooks/load-more/usePaginationPC';
import dayjs from 'dayjs';
import { useReportCore } from '@rebuild/materials/shared/report/context';
import { useCurrentContext } from './context';
import i18n, { ZH_HK, getLanguageType } from '@/locales';

const { isSZ003010 } = useCurrentContext();

const { handlePreview, loadData, report, isLoading, isEmpty, currentData } = useReportCore();

const searchValue = ref('');

const handlePaginationChange = () => {
	refreshComponent();
};

const formatDateFn = date => {
	return dayjs(date).format('YYYY-MM-DD');
};

const {
	currentPage,
	pageSize,
	pageSizes,
	pageLayout,
	pageTotal,
	changePageSize,
	changeCurrentPage,
	changePageTotal,
	refreshPagination
} = usePaginationPC({
	bindChange: handlePaginationChange
});

const refreshComponent = async () => {
	const params = {
		pagestart: currentPage.value - 1,
		pagenum: pageSize.value,
		keyword: searchValue.value
	};

	//若羽臣定制化需求
	if(isSZ003010) {
		params.sourceLanguageType = i18n.locale === ZH_HK ? 1 : getLanguageType();
		params.manyStock = 1
	}
	await loadData(params);

	const total = Number(report.data?.total || 0);
	changePageTotal(total);
};

const changeSearch = () => {
	refreshPagination();
};


onMounted(() => {
	refreshComponent();
});
</script>

<style lang="less" scoped>
.content-module-container {
	.content-module-block {
		border-radius: 2px;
		background: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		h2 {
			color: #1d2129;
			font-size: 28px;
			font-weight: 500;
			line-height: 140%;
		}
	}
	.report-list {
		margin-top: 35px;
		display: flex;
		flex-flow: row wrap;
		&--item {
			width: calc(50% - 20px);
			margin-bottom: 24px;
			&:nth-child(2n-1) {
				margin-right: 40px;
			}
		}

		.date {
			font-size: 14px;
			font-weight: 400;
			line-height: 18px;
			color: #4e5969;

			&--report {
				display: flex;
				align-items: center;
				flex: 1;
				width: 0;
			}
			.one-line {
				display: block;
				max-width: 72%;
			}
		}
	}
}
</style>
